module.exports = __webpack_public_path__ + "img/victoria_maraia_3.22d58c88.jpg";